import { render, staticRenderFns } from "./ComponentTemplatesMixin.vue?vue&type=template&id=50f87b9a&"
import script from "./ComponentTemplatesMixin.vue?vue&type=script&lang=js&"
export * from "./ComponentTemplatesMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports